import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stringSorter } from "../../utils/functions.js";
import DataTable from "../../components/CustomDatatable/index.js";
import {
  Button,
  Card,
  Space,
  Typography,
  Breadcrumb,
  Row,
  Col,
  Switch,
  message,
  Modal,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  HomeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Spinner } from "reactstrap";
import {
  addCountry,
  deleteCountry,
  getCountries,
  updateCountry,
  updateCountryStatus,
} from "../../store/actions/country.js";
import CountryForm from "./CountryForm.js";

const { Title } = Typography;

const Country = () => {
  document.title = "Country";
  const [isLoading, setIsLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const dispatch = useDispatch();
  const country = useSelector((state) => state.country.list);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        await dispatch(getCountries());
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching countries:", error);
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, [dispatch]);

  const handleCreate = async (values) => {
    let success = false;

    if (selectedRecord) {
      success = await dispatch(updateCountry({ id: selectedRecord.id, ...values }));
    } else {
      success = await dispatch(addCountry(values));
    }

    if (success) {
      setIsModalVisible(false);
      dispatch(getCountries());
    }
  };

  const handleChangeStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === 1 ? 0 : 1;
    await dispatch(updateCountryStatus({ id, status: newStatus }));
    await dispatch(getCountries());
  };

  const handleDelete = (item) => {
    setItemToDelete(item);
    setDeleteModalVisible(true);
  };
  const confirmDelete = async () => {
    try {
      await dispatch(deleteCountry(itemToDelete.id));
      setDeleteModalVisible(false);
      await dispatch(getCountries());
    } catch (error) {
      message.error("An error occurred while deleting the item");
    }
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: stringSorter("name"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Nationality",
      dataIndex: "nationality",
      key: "nationality",
      sorter: stringSorter("nationality"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Country Code",
      dataIndex: "code",
      key: "code",
      sorter: stringSorter("code"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Flag",
      dataIndex: "icon",
      key: "icon",
      sorter: stringSorter("icon"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Image",
      dataIndex: "imagepath",
      key: "imagepath",
      sorter: stringSorter("imagepath"),
      sortDirections: ["ascend", "descend"],
      render: (imagepath, record) => (
        <>
          {/* {console.log("image path :", imagepath)} */}

          <img
            src={imagepath}
            alt={record.name || "Country icon"}
            style={{ maxWidth: "100px", maxHeight: "100px" }}
            crossOrigin="anonymous"
          />
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <Switch
          checked={text === 1}
          onChange={() => handleChangeStatus(record.id, text)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setSelectedRecord(record);
              setIsModalVisible(true);
            }}
          >
            <EditOutlined />
          </Button>

          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record)}
          >
            {/* Delete */}
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
       <Breadcrumb.Item href="/dashboard">Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Country</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={2} style={{ margin: 0 }}>
                Manage Country
              </Title>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectedRecord(null);
                  setIsModalVisible(true);
                }}
              >
                Add Country
              </Button>
            </Col>
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <DataTable
              dataSource={country.map((item) => ({
                ...item,
                key: item.id,
                status: item.status ? 1 : 0, // Convert boolean to 1/0
              }))}
              columns={columns}
            />
          )}
        </Space>
      </Card>
      <CountryForm
        visible={isModalVisible}
        onCreate={handleCreate}
        onCancel={() => setIsModalVisible(false)}
        record={selectedRecord}
      />

      <Modal
        title="Confirm Delete"
        zIndex={100000000}
        visible={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setDeleteModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="delete" danger onClick={confirmDelete}>
            Delete
          </Button>,
        ]}
      >
        <p>Are you sure you want to delete this item?</p>
        {itemToDelete && (
          <p>
            <strong>Record Name:</strong> {itemToDelete.name}
          </p>
        )}
      </Modal>
    </div>
  );
};

export default Country;


